import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { ExistsService } from './exists.service';

const service = new ExistsService();

export interface ExistsState {}

const ExistsStore: Module<ExistsState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getExists(
         context,
         {
            candidateId,
            first_name,
            last_name,
            phone_number,
            email,
            social_security_number,
         }: {
            candidateId: number;
            first_name?: string;
            last_name?: string;
            phone_number?: string;
            email?: string;
            social_security_number: { social_security_number: string; social_security_number_mask_type_id: number };
         },
      ) {
         const response = await service.getExists(candidateId, first_name, last_name, phone_number, email, social_security_number);
         return response;
      },
   },
};

export default ExistsStore;
